import React, { useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { Button } from "semantic-ui-react";

import IPriestProfileData from "../../data/priest/PriestProfileData";
import ExportPriestDialog from "./ExportPriestDialog";

interface IExportPriestButtonProps {
    priests: IPriestProfileData[];
}

const ExportPriestButton: React.FC<IExportPriestButtonProps> = (props: IExportPriestButtonProps) => {
    const { priests } = props;
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button color="violet" fluid onClick={() => setOpen(true)} size="large">
                <FM id="profile.excelExport" />
            </Button>
            <ExportPriestDialog onClose={() => setOpen(false)} open={open} priests={priests} />
        </>
    );
};

export default ExportPriestButton;
